import RepositoryInfo from './repositoryInfoType';

const emptyRepositoryInfo: RepositoryInfo = {
  RepoDescription: '',
  RepoName: '',
  RepoUrl: '',
  VectorDBUrl: '',
  LatestCommitTitle: '',
  LatestCommitUrl: '',
  LastUpdateTimestamp: '',
};

export default emptyRepositoryInfo;
